import { ALERT_SHOW, ALERT_CLOSE } from "constants/action-types";

export const showAlert = message => ({
  type: ALERT_SHOW,
  payload: {
    message
  }
});

export const closeAlert = () => ({
  type: ALERT_CLOSE
});



// WEBPACK FOOTER //
// ./src/actions/common/alert.js